import type { Tour } from '../tour-types';

/**
 * Google Analytics, the connected Google accounts. The row steps point at the first row,
 * so they need one connected account; with none the empty state holds the tour back.
 * Which property a website is linked to shows on the Websites list, not here.
 */
export const googleAnalyticsTour: Tour = {
  key: 'google-analytics',
  version: 1,
  routes: ['/websites/google-analytics'],
  steps: [
    {
      anchor: 'ga-connect',
      placement: 'left',
      requires: 'integrations:manage',
      title: 'Connect Google',
      body: 'Sign in with the Google account that owns your Analytics property, so experiments can send their variants to it and read conversions back.',
    },
    {
      anchor: 'ga-login',
      title: 'Google login',
      body: 'The Google login Pertento reaches Analytics through. Its access in Google decides which properties Pertento can see and whether it can edit them.',
    },
    {
      anchor: 'ga-accounts',
      placement: 'bottom',
      title: 'Analytics accounts',
      body: 'How many Google Analytics accounts this login can reach. A website linked to one of their properties shows it in the Tracking column of the Websites list.',
    },
    {
      anchor: 'ga-refresh',
      placement: 'left',
      requires: 'integrations:manage',
      title: 'Refresh',
      body: 'Reads the accounts and properties from Google again, for when something changed there since Last Updated. You get an email when it is done.',
    },
  ],
};
